<template>
<div class="modal-mask">
    <div class="modal-wrapper">
        <div class="modal_size md_size">
            <a href="javascript:" class="ui_close" type="button" @click="$emit('close')"><span class="sr_only">popup close</span></a>
            <dl class="modal_content">
                <dt class="ellipsis">
                    <i>Template</i>
                </dt>
                <dd>
                    <ul class="template_list">
                        <li>
                            <p class="template_img" @click="handleClick('SB')">
                                <img src="/static/images/pic_template_01.png" alt="template img">
                            </p>
                            <span>Service Bulletion</span>
                        </li>
                        <!-- 
                        <li>
                            <p class="template_img" @click="handleClick('RT')">
                                <img src="/static/images/pic_template_02.png" alt="template img">
                            </p>
                            <span>Repair Tip</span>
                        </li>
                        -->
                        <li>
                            <p class="template_img" @click="handleClick('CG')">
                                <img src="/static/images/pic_template_03.png" alt="template img">
                            </p>
                            <span>Call Guide</span>
                        </li>
                        <li>
                            <p class="template_img" @click="handleClick('BP')">
                                <img src="/static/images/pic_template_04.png" alt="template img">
                            </p>
                            <span>Blank Page</span>
                        </li>
                    </ul>
                </dd>
                <!-- 200707수정(버튼 하단으로 이동) S -->
                <dd class="scroll_btm">
                    <div class="tooltip_wrap fl_right">
                        <em class="ico_info_lg">
                            <i class="tooltip fl_right">{{ $t('MESSAGE.KNOWLEDGE.TEMPLATE.TOOLTIP') }}</i>
                            <span class="sr_only">info</span>
                        </em>
                    </div>
                </dd>
                <!-- 200707수정(버튼 하단으로 이동) E -->
            </dl>
        </div>
    </div>
</div>
</template>
<script>
import Vue                  from 'vue';
import { SDLUtil }          from '@/utils';

//import ServiceBulletinTemp  from '/static/sample/CREATE_Template_01.html';
import ServiceBulletinTemp  from '/static/sample/CREATE_Template_02.html';
//import RepairTipTemp        from '/static/sample/CREATE_Template_02.html';
import CallGuideTemp        from '/static/sample/CREATE_Template_03.html';
import BlankPageTemp        from '/static/sample/CREATE_Template_04.html';

const fetchHtml = path => axios.get(`${SDLUtil.WEB_CONTEXT_PATH}${path}`);

export default {
    name: 'KnowledgeTemplatePopup',
    props: {
        rtnFunc: { type: Function }
    },
    methods: {
        handleClick(type) {
            let doc = '';
            switch(type) {
                case 'SB' : doc = ServiceBulletinTemp; break;
                case 'RT' : doc = RepairTipTemp; break;
                case 'CG' : doc = CallGuideTemp; break;
                case 'BP' : doc = BlankPageTemp; break;
                default   : doc = BlankPageTemp; break;
            };

            this.rtnFunc(doc);
            this.$emit('close');
        }
    }
};
</script>


// WEBPACK FOOTER //
// src/skpComponents/view/basis/knowledge/popup/KnowledgeTemplatePopup.vue